export default __webpack_public_path__ + "static/media/front2cropped.3f850b1d.png";